import React, { FC } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useFixFlowProvider } from 'modules/contracts/components/FixFlow/FixFlowProvider'

const Footer: FC = () => {
  const { onSubmit: onFixContract, form: contractForm, isSubmitting } = useFixFlowProvider()

  const isDirty = contractForm?.isDirty
  const disabled = isSubmitting

  const onSubmitFixContract = () => {
    asyncAction(() => {
      return new Promise<void>((resolve) => {
        onFixContract(() => {
          app.setFlash({
            type: 'correct',
            message: i18n.t('common.saved_successfully'),
          })
          resolve()
        })
      })
    })
  }

  const buttonText = disabled ? i18n.t('common.please_wait') : i18n.t('common.submit')
  return (
    <Box alignSelf="flexEnd">
      {isDirty && (
        <Button disabled={disabled} onClick={() => onSubmitFixContract()}>
          {buttonText}
        </Button>
      )}
    </Box>
  )
}

export default observer(Footer)
